import Vue from 'vue';

export default {

  SET_DESTINATION_WORK_HEADERS(state, data) {
    state.destinationWorkHeaders = data;
  },
  SET_MASTER_MAP(state, payload) {
    Vue.set(state.masterMap, payload.masterName, payload.masterList);
  },
  SET_DESTINATION_WORK_TASK(state, payload) {
    if ( ! state.destinationWorkTasksMap[payload.date] ) {
      state.destinationWorkTasksMap[payload.date] = {};
    }
    state.destinationWorkTasksMap[payload.date][payload.taskId] = payload.destinationWorkTask;
  },
  DELETE_DESTINATION_WORK_TASK(state, payload) {
    if ( state.destinationWorkTasksMap[payload.date] ) {
      delete state.destinationWorkTasksMap[payload.date][payload.taskId];
    }
  },
  ADD_FIRESTORE_SUBSCRIBE_LIST(state, data) {
    state.firestoreSubscribeList.push(data);
  },
  SET_TARGET_DATES(state, data) {
    state.displayDates = data;
  },
  UNSUBSCRIBE_FIRESTORE(state) {
    if (state.firestoreSubscribeList.length > 0) {
      state.firestoreSubscribeList.forEach(unsubscribe => {
        unsubscribe();
      });
    }
  },
  SET_LAST_UPDATED_TIME_MAP(state, data) {
    Vue.set(state.lastUpdatedTimeMap, data.date, data.time);
  },
  SET_LAST_UPDATED_FOR_MONITORS(state, data) {
    state.lastUpdatedForMonitors = data;
  },
  SET_LAST_UPDATED_FOR_COLUMNS(state, data) {
    state.lastUpdatedForColumns = data;
  },
  SET_LAST_UPDATED_FOR_MASTERS(state, data) {
    state.lastUpdatedForMasters = data;
  },
  SET_LAST_UPDATED_FOR_TASKS(state, data) {
    state.lastUpdatedForTasks = data;
  },
  SET_MONITOR_SETTING_MAP(state, data) {
    state.monitorSettingMap[data.id] = data.setting;
  },
  SET_SELECTED_DATE_DISPLAY1(state, data) {
    state.selectedDateDisplay1 = data;
  },
  SET_VESSEL_NAME_JAPANESE_FLG(state, data){
    state.vesselNameJapaneseFlg = data;
  },
  SET_PILOT_COLOR_FLG(state, data){
    state.pilotColorFlg = data;
  },
  SET_SELECTED_CELL(state, data) {
    state.selectedTaskId = data.taskId;
    state.selectedColumnKey = data.columnKey;
  },
  SET_SUMMARY_DIALOG_SHOW_POPUP(state, data) {
    state.summaryDialogShowPopup = data;
  },
}
